<div class="sidebar-form" #sidebar>
  <app-search-input
    [placeholder]="'widget-sidebar.search.placeholder' | translate"
    (inputChanged)="handleInputChange($event)"
    #widgetInput
  ></app-search-input>

  <div class="select-wrapper">
    <span>{{ "widget-sidebar.label.show" | translate }}:</span>
    <sui-combobox
      [options]="groupOptions"
      [ngModel]="currentGroupId"
      (ngModelChange)="currentGroupId = $event; onOptionChange($event)"
      [dropdownContainer]="dropdownBoundary"
    ></sui-combobox>
  </div>

  <sui-checkbox
    class="enable-preview-label"
    [(ngModel)]="pivotableOnly"
    [ngModelOptions]="{ standalone: true }"
    (checkedChange)="onPivotableToggle()"
  >
    {{ "widget-sidebar.controls-section.pivotable-only" | translate }}
  </sui-checkbox>
  <div
    class="preview-datasource-select"
    *ngIf="objectClassId == nomObjectClass.DASHBOARD"
  >
    <div>{{ "widget-sidebar.label.preview-datasource" | translate }}</div>
    <sui-combobox
      [options]="(feedOptions$ | async) ?? []"
      [compareWith]="compareFeed"
      [ngModel]="defaultPreviewFeed"
      (ngModelChange)="defaultPreviewFeed = $event; defaultPreviewFeedChange()"
      [dropdownContainer]="dropdownBoundary"
    ></sui-combobox>
  </div>
  <div class="create-section">
    <sui-button
      variant="primary"
      [disabled]="!previewWidget"
      (click)="createWidget()"
    >
      {{ "picker-widgets.button.create" | translate }}
    </sui-button>

    <sui-checkbox
      class="enable-preview-label"
      [(ngModel)]="enablePreview"
      [ngModelOptions]="{ standalone: true }"
    >
      {{ "widget-sidebar.controls-section.enable-preview" | translate }}
    </sui-checkbox>
  </div>
</div>
<div class="widget-list-content">
  <div class="preset-card-container">
    <app-loading *ngIf="widgetPresetsLoading$ | async"></app-loading>
    <ng-container *ngIf="widgetPresetsFiltered.length > 0; else noPresets">
      <app-widget-preset-card
        *ngFor="
          let widgetPreset of widgetPresetsFiltered | sort: 'display_order';
          trackBy: trackByFn
        "
        [widgetPreset]="widgetPreset"
        [highlight]="searchString"
        [selectedPresetId]="selectedPresetId"
        [selectedChartTypeId]="selectedChartTypeId"
        [dataSourceObjectId]="getDataSourceObjectId()"
        [dataSourceObjectClassId]="getDataSourceObjectClassId()"
        (onWidgetPreview)="onWidgetPreview($event)"
        (onWidgetCreate)="onWidgetCreate($event)"
      ></app-widget-preset-card>
    </ng-container>
    <ng-template #noPresets>
      <!-- Content to display when widgetPresetsFiltered.length is 0 -->
      <p>{{ "widget-sidebar.message.no-presets-available" | translate }}</p>
    </ng-template>
  </div>
</div>

<app-widget-preview-popup
  #previewPopup
  *ngIf="showPreview$ | async"
  [style.position]="'fixed'"
  [style.top.px]="popupTop"
  [style.left.px]="popupLeft"
  [style.z-index]="ZIndex.DIALOG"
  [hidden]="!enablePreview"
  [rtl]="rtl"
  [widget]="previewWidget"
  [isLoading]="previewIsLoading"
  [width]="currentPopupWidth"
  [height]="currentPopupHeight"
  (close)="closeWidgetPreviewPopup()"
  (dock)="dockWidgetPreviewPopup()"
  cdkDrag
  cdkDragBoundary="body"
  [cdkDragFreeDragPosition]="dragPosition"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragMoved)="onDragMoved($event)"
  (cdkDragEnded)="onDragEnded()"
></app-widget-preview-popup>
